import * as actionTypes from './actionTypes'
import { enqueueSnackbar } from './alert'
import dashboardOverallPerformaceAxios from '../../axios/dashboardOverallPerformance'

export const fetchDashboardOverallPerformace = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }
    dispatch(fetchDashboardOverallPerformaceStart())
    dashboardOverallPerformaceAxios
      .get('/chart', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const data = response.data.data

          dispatch(fetchDashboardOverallPerformaceSuccess(data))
        }
      })
      .catch(error => {
        switch (error?.response?.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Fetch Dashboard Overall Performace Failed',
                options: {
                  variant: 'error',
                  data: error?.response?.data?.data ?? []
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error?.response?.data?.message ?? '',
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(fetchDashboardOverallPerformaceFailed(error))
      })
  }
}

export const fetchDashboardOverallPerformaceStart = () => {
  return {
    type: actionTypes.FETCH_DASHBOARD_OVERALL_PERFORMANCE_START
  }
}

export const fetchDashboardOverallPerformaceSuccess = records => {
  return {
    type: actionTypes.FETCH_DASHBOARD_OVERALL_PERFORMANCE_SUCCESS,
    records
  }
}

export const fetchDashboardOverallPerformaceFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_DASHBOARD_OVERALL_PERFORMANCE_FAILED,
    errorMessage
  }
}

export const clearSelectedThresholdGroupRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_DASHBOARD_OVERALL_PERFORMANCE_RECORD
  }
}
